<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            菜单管理
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" plain @click="sortMune">排序</el-button>
                </el-row>

                <div style="height: 10px;"></div>

                <div :style="contentStyleObj">
                    <template>
                        <el-tree
                                v-loading="loading"
                                :data="listMenuDTO"
                                node-key="Code"
                                default-expand-all
                                :expand-on-click-node="false">

                          <span class="custom-tree-node" slot-scope="{ node, data }">

                            <span  style="width:100%">

                                <div style="width:300px;float: left;">
                                    <span class="sp">名称：{{ node.data.name }}</span>
                                </div>

                                <el-row style="width:600px;float: right;">
                                    <el-col :span="24" class="item">
                                         <span class="sp">路由：{{ node.data.url }}[{{ node.data.icon}}][{{ node.data.sort}}]</span>
                                    </el-col>
<!--                                    <el-col :span="8" class="item">-->
<!--                                        <span class="sp">图标：[{{ node.data.icon}}][{{ node.data.sort}}]</span>-->
<!--                                    </el-col>-->
                                </el-row>
                            </span>

                            <span>
                                <el-button type="text" size="small" icon="el-icon-circle-plus-outline" @click="() => append(data)"></el-button>
                                <el-button type="text" size="small" icon="el-icon-edit" @click="() => updateMune(data)"></el-button>
                                <el-button type="text" size="small" icon="el-icon-delete" @click="() => remove(node,data)"></el-button>
                            </span>

                          </span>
                        </el-tree>
                    </template>
                </div>

            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-bind:listMenuDTO="listMenuDTO" v-on:menuShow="menuShow"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:listMenuDTO="listMenuDTO" v-on:closeEdit="closeEdit" v-on:menuShow="menuShow"></Edit>
        <Sort ref="mySort" v-show="showModalSort" v-bind:listMenuDTO="listMenuDTO"  v-on:closeSort="closeSort"  v-on:menuShow="menuShow"></Sort>

    </div>
</template>

<script>

    import Add from "./Add";
    import Edit from "./Edit";
    import Sort from "./Sort";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: "List",
        components:{
            Add,Edit,Sort
        },
        data() {
            return {
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                showModalSort:false,
                listMenuDTO:[],

                th:0,
                contentStyleObj: {
                    padding:'0px',
                    backgroundColor:'#fff',
                    overflowY:'auto',
                    height: ''
                },

            }
        },
        created(){
            this.menuShow();

            this.th = this.$store.state.tableHeight;
            this.contentStyleObj.height = this.th +50 +"px";

        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
                this.contentStyleObj.height = this.th+50 +"px";
            },
        },


        methods:{

            menuShow(){
                this.loading = true;

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Menu/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {

                        if (response.data.error == 0) {
                            this.loading = false;

                            this.listMenuDTO = response.data.data;
                            let aa =  JSON.stringify(this.listMenuDTO).replace(/listMenuDTO/g,"children");
                            this.listMenuDTO = JSON.parse(aa);


                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.loe(response.data.message);
                        }

                    }
                )
            },

            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init("");
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },

            closeSort:function(){
                this.showModalSort = !this.showModalSort;
            },

            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            append(data) {
                 this.showModalAdd = !this.showModalAdd;
                 this.$refs.myAdd.init(data.menuCode);

            },
            updateMune(data){
                console.log(data);
                this.showModalEdit = !this.showModalEdit;
                this.$refs.myEdit.init(data)
            },
            sortMune(){
                console.log();
                this.showModalSort = !this.showModalSort;
                this.$refs.mySort.init()
            },
            remove(node, data) {
                this.$confirm('删除该菜单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const parent = node.parent;
                    const children = parent.data.children || parent.data;
                    const index = children.findIndex(d => d.menuCode === data.menuCode);
                    console.log(index);
                    children.splice(index, 1);
                    console.log(JSON.stringify(this.listMenuDTO));
                    this.save();
                }).catch(() => {
                    this.$message({type: 'info', message: '已取消删除'});
                });
            },
            save(){
                let aa = JSON.stringify(this.listMenuDTO);
                aa = aa.replace(/children/g, "listMenu");

                let data = {
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode:getStaffCode(),
                    listMenu:JSON.parse(aa)
                };
                //console.log(JSON.stringify(data));

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Menu/Edit",
                    data:data
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.$message({message: '删除成功', type: 'success'});
                            this.menuShow();
                        }else{
                            this.$message({message: '删除失败'});
                        }
                    }
                )
            },






        },

    }

</script>


<style>

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        padding-right: 8px;
    }
    .el-button--text{
        font-size: 16px;
    }
    .el-tree-node__content{
        height: auto;
    }
    .sp{
        margin-right: 20px;
    }


</style>

